import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-redux-i18n';
import cartoucheHomme from '../../img/cartouche_homme.png';
import cartoucheFemme from '../../img/cartouche_femme.png';
import { logout } from '../../services/userService';
import { MonIdentite } from '../../network/api/types/compte/MonIdentite';
import CloseableComponent from './CloseableComponent';
import { getLinks } from '../../network/api/links';
import rightChevron from '../../img/icones/chevron_droite.svg';

type Props = {
  myIdentity?: MonIdentite,
};

type State = {
  isOpen: boolean,
};

class UserTile extends React.Component<Props, State> {
  state: State = {
    isOpen: false,
  };

  buttonReference = React.createRef<HTMLButtonElement>();

  logoutPage = (): void => {
    logout();
    window.location.href = getLinks().disconnectionLink;
  };

  toggle = (): void => this.setState((previousState) => ({
    isOpen: !previousState.isOpen,
  }));

  getAvatar = (): JSX.Element => {
    const cartouche = this.props.myIdentity.civilite.toUpperCase() === 'MONSIEUR' ? cartoucheHomme : cartoucheFemme;
    return (<img alt="Profile pic" src={this.props.myIdentity.photo || cartouche} />);
  };

  render(): ReactNode {
    if (!this.props.myIdentity) {
      return false;
    }
    return (
      <div className="user-tile">
        <hr className="vertical-divider" />
        <div className="picture">
          {this.getAvatar()}
        </div>
        <CloseableComponent
          isOpened={this.state.isOpen}
          toggle={this.toggle}
          buttonRef={this.buttonReference.current}
        >
          <div className="idnot-links">
            <div className="container-links">
              <button type="button" onClick={this.logoutPage}>
                <Translate value="HEADER.DISCONNECT" />
              </button>
            </div>
          </div>
        </CloseableComponent>
        <button
          type="button"
          onClick={this.toggle}
          className="user-information-container"
          ref={this.buttonReference}
        >
          <div className="user-information">
            <span>{this.props.myIdentity.prenom}</span>
            <span>{this.props.myIdentity.nomUsuel}</span>
          </div>
          <img className={`chevron ${this.state.isOpen ? 'face-up' : 'face-bottom'}`} src={rightChevron} alt="" />
        </button>
        <hr className="vertical-divider" />
        <a
          target="_blank"
          rel="noreferrer"
          aria-label="Notacces"
          href="https://intra.notaires.fr/jcms/lpo_3000242/fr/services"
          className="notacces-button with-tooltip"
        >
          <i className="fa fa-th" />
          <div className="tooltip left">
            <div className="arrow-up" />
            <div className="tooltip-content">
              <Translate
                value="HEADER.notaccess"
              />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default connect((state) => ({
  myIdentity: state.user.myIdentity,
}), {
})(UserTile);
